export interface PublishedApk {
  versionCode: number | null;
  versionName: string | null;
}

export interface InstalledApk {
  versionCode: number;
  versionName: string;
}

/**
 * The published APK worth offering: newer than the installed one and not the one the user
 * waved away. A later build shows up again even after a dismissal.
 */
export function apkUpdate(installed: InstalledApk | null, published: PublishedApk | null, dismissedCode: number | null): PublishedApk | null {
  if (!installed || !published || published.versionCode === null) return null;
  if (published.versionCode <= installed.versionCode) return null;
  if (dismissedCode !== null && dismissedCode >= published.versionCode) return null;
  return published;
}
